module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Regular.ed1d014.ttf";